import React from 'react';
import { PlusCircleSolid } from '@alefeducation/ui-elements-library-icons';
import { Button } from '@alefeducation/ui-elements-library-core';
import { useHistory } from 'react-router-dom';
import { ROUTE_RNP } from '../../Routing/routeHelpers';
import { CREATE_NEW_ROLE } from '../../../utils/constants';

const CreateNewRoleButton = () => {
  const history = useHistory();

  return (
    <Button
      variant="primary"
      size="lg"
      icon={<PlusCircleSolid />}
      onClick={() => {
        history.push(ROUTE_RNP.createNewRole);
      }}
    >
      {CREATE_NEW_ROLE}
    </Button>
  );
};

export default CreateNewRoleButton;
